import {Message} from 'element-ui';
import { Notification } from 'element-ui';


export default new class NotifyMessage {
    notifyError(message) {
        Message({
            message: message,
            type: "error",
            duration: 4000,
            showClose: true,
        });
    }

    notifySuccess(message) {
        Message({
            message: message,
            type: "success",
            duration: 4000,
            showClose: true,
        });
    }

    leftCornerNotificationSuccess(message) {
        Notification.success({
            title: "Thông báo",
            message: message,
            duration: 5000,
            dangerouslyUseHTMLString: true,
        });
    }

    leftCornerNotificationInfo(message) {
        Notification.info({
            title: "Thông báo",
            message: message,
            duration: 5000,
            dangerouslyUseHTMLString: true,
        });
    }

    leftCornerNotificationError(message) {
        Notification.error({
            title: "Thông báo",
            message: message,
            duration: 5000,
            dangerouslyUseHTMLString: true,
        });
    }

    leftCornerNotificationWarning(message) {
        Notification.warning({
            title: "Thông báo",
            message: message,
            duration: 5000,
            dangerouslyUseHTMLString: true,
        });
    }




};

